export type TextboxCardProps = {
  className?: string;
  title?: string;
  subtitle?: string;
  body?: string;
};

export const TextboxCard = ({ title, subtitle, body }: TextboxCardProps) => {
  return (
    <article className="bg-neutral-80 text-neutral-0 text-center p-3 sm:p-12">
      <div className="cap-xs sm:cap-sm">{subtitle}</div>
      <h1 className="body-base sm:body-lg my-2">{title}</h1>
      <p className="body-xs sm:body-sm">{body}</p>
    </article>
  );
};

export default TextboxCard;
